import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withRoomContext } from '../../../RoomContext';
import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';
import { FormattedMessage } from 'react-intl';
import {
	peersLengthSelector
} from '../../Selectors';
import * as bottomNavigationActions from '../../../actions/bottomNavigationActions';
import * as settingsActions from '../../../actions/settingsActions';
import * as chatActions from '../../../actions/chatActions';
import * as roomActions from '../../../actions/roomActions';
import Icons from '../Common/Icons';

// firebase
import { storage } from '../../../lib/firebase';
import GuestSettingsDialog from './GuestSettingsDialog';

const styles = () =>
	({
		root :
		{
			width           : '100%',
			height          : '14%',
			maxHeight       : '90px',
			minHeight       : '70px',
			position        : 'fixed',
			bottom          : 0,
			display         : 'flex',
			backgroundColor : '#e5e5e2',
			padding         : '1% 4% 1% 4%',
			alignItems      : 'center'
		},
		rootM :
		{
			width           : '100%',
			height          : '12%',
			maxHeight       : '90px',
			display         : 'flex',
			backgroundColor : '#e5e5e2',
			padding         : '1%',
			alignItems      : 'center'
		},
		rootML :
		{
			width           : '20%',
			height          : '100%',
			bottom          : 0,
			display         : 'flex',
			backgroundColor : '#e5e5e2',
			padding         : '1%',
			alignItems      : 'center',
			justifyContent  : 'center'
		},
		rootJoinView : {
			'@media (max-height:751px)' : // eslint-disable-line no-useless-computed-key
			{
				display : 'none'
			}
		},
		controls :
		{
			width          : '100%',
			display        : 'flex',
			justifyContent : 'space-evenly',
			alignItems     : 'center',
			padding        : '0 20%',
			whiteSpace     : 'nowrap'
		},
		controlsM :
		{
			width          : '100%',
			display        : 'flex',
			justifyContent : 'space-evenly',
			alignItems     : 'center',
			padding        : '0%',
			whiteSpace     : 'nowrap'
		},
		controlsML :
		{
			height         : '100%',
			display        : 'flex',
			flexDirection  : 'column',
			justifyContent : 'space-evenly',
			alignItems     : 'center',
			padding        : '0%',
			whiteSpace     : 'nowrap'
		},
		controlBtn :
		{
			width           : '10%',
			padding         : '1%',
			borderRadius    : '0.5rem',
			aspectRatio     : 1,
			backgroundColor : 'transparent',
			'&:hover'       : {
				cursor          : 'pointer',
				backgroundColor : '#fff'
			},
			'& .MuiButton-label' : {
				flexDirection : 'column',
				fontSize      : '0.8rem'
			}
		},
		controlBtnDisabled :
		{
			width                : '10%',
			padding              : '1%',
			borderRadius         : '0.5rem',
			aspectRatio          : 1,
			'& .MuiButton-label' : {
				flexDirection : 'column',
				fontSize      : '0.8rem'
			}
		},
		controlBtnIcon :
		{
			color     : '#999898',
			'&:hover' : {
				color : '#9ec317'
			}
		},
		controlBtnLabel :
		{
			color      : '#999898',
			fontSize   : '0.8rem',
			lineHeight : '0.8rem'
		},
		controlBtnLabelM :
		{
			fontSize : '0.65rem'
		},
		logoBg :
		{
			backgroundColor : '#e5e5e2',
			padding         : '0.1%',
			borderRadius    : '1rem'
		},
		logo :
		{
			width     : 'auto',
			height    : 'auto',
			maxHeight : '50px',
			maxWidth  : '150px'
		},
		hiddenInput :
		{
			display : 'none'
		},
		buttonCircular : {
			color  : '#adadac',
			height : '22.5px !important',
			width  : '22.5px !important'
		}
	});

const GuestBottomNavi = ({
	room,
	roomClient,
	classes,
	isMobile,
	chatEnabled,
	setChatEnabled,
	settings,
	setVideoMuted,
	orientation,
	uploadedShareFile,
	setMakeCallEnd,
	numOfRecievedChats,
	hideGuestBottomNavi
}) =>
{

	const hiddenFileInput = useRef();

	const [ isUploadingFile, setIsUploadingFile ] = useState(false);

	const [ showChatBadge, setShowChatBadge ] = useState(false);

	const [ settingsDialogOpen, setSettingsDialogOpen ] = useState(false);

	const handleCameraBtn = () =>
	{
		if (settings.videoMuted)
		{
			roomClient.updateWebcam({ start: true });
		}
		else
		{
			roomClient.disableWebcam();
		}
		setVideoMuted(!settings.videoMuted);
	};

	const handleMicBtn = async () =>
	{
		if (settings.audioMuted)
		{
			await roomClient.unmuteMic();
		}
		else
		{
			await roomClient.muteMic();
		}
		// setAudioMuted(!settings.audioMuted);
	};

	const createFileShareInfo = (sender, name, pic, fileName, fileShareUrl) =>
		({
			type    : 'file',
			time    : Date.now(),
			name,
			sender,
			picture : pic,
			fileName,
			fileShareUrl
		});

	const startShareFile = () =>
	{
		hiddenFileInput.current.click();
	};

	const handleShareFile = async (event) =>
	{

		const fileUploaded = event.target.files[0];

		const fileReader = new FileReader();

		fileReader.onload = async function()
		{
			try
			{
				setIsUploadingFile(true);

				let url='';

				const fileName=fileUploaded.name;

				const timeNow = new Date().getTime();
				// firebase storage  room.name is id of room collection
				const storageref = storage.ref(`/sharedFiles/${room.name}/${timeNow}-${fileName}`);

				const snapshot = await storageref.put(fileUploaded);

				url = await snapshot.ref.getDownloadURL();

				if (url)
				{
					const fileInfo = createFileShareInfo('response', settings.displayName, null, fileName, url);

					roomClient.shareFirebaseFile(fileInfo);
					setIsUploadingFile(false);
				}
				else
				{
					// notify error
					uploadedShareFile({
						fileName     : fileName,
						fileShareUrl : '',
						error        : true
					});
					setIsUploadingFile(false);
				}
			}
			catch
			{
				// notify error
				uploadedShareFile({
					fileName     : fileUploaded.name,
					fileShareUrl : '',
					error        : true
				});
				setIsUploadingFile(false);
			}

		};

		try
		{
			fileReader.readAsDataURL(fileUploaded);
		}
		catch
		{
			// notify error
			uploadedShareFile({
				fileName     : 'ファイル',
				fileShareUrl : '',
				error        : true
			});
		}
	};

	const handleChatBtn = () =>
	{
		setChatEnabled(!chatEnabled);
		setShowChatBadge(false);
	};

	const handleCloseBtn = () =>
	{
		roomClient.forceClose();
		setMakeCallEnd(true);
	};

	useEffect(() =>
	{
		// when not showing chat tab. room.state of initial rendering is 'new'
		if (room.state === 'connected' && !chatEnabled)
		{
			setShowChatBadge(true);
		}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ numOfRecievedChats ]);

	return (
		<>
			<GuestSettingsDialog
				settingsDialogOpen={settingsDialogOpen}
				closeSettingsDialog={() => setSettingsDialogOpen(false)}
			/>
			{ (!hideGuestBottomNavi && (room.state === 'connected' || !isMobile)) &&
				<div className={isMobile ?
					orientation === 'portrait' ? classes.rootM : classes.rootML
					:
					room.state === 'connected' ? classes.root : `${classes.root} ${classes.rootJoinView}`
				}
				>
					{ (!isMobile && room.logoUrl) &&
					<div className={classes.logoBg}>
						<img
							alt='logo'
							src={room.logoUrl}
							className={classes.logo}
						/>
					</div>
					}

					{ room.state === 'connected' &&
					<>
						<div className={isMobile ?
							orientation === 'portrait' ? classes.controlsM : classes.controlsML
							:
							orientation === 'portrait' ? classes.controls : classes.controls
						}
						>
							<Button
								className={classes.controlBtn}
								onClick={() => handleCameraBtn()}
								color='primary'
							>
								<div className={classes.controlBtnIcon}>
									<Icons category={'guest'} iconName={'camera'} type={settings.videoMuted ? 'active' : 'normal'} size={'1.5rem'}/>
								</div>
								<div className={classes.controlBtnLabel}>
									<FormattedMessage
										id='label.camera'
										defaultMessage='Camera'
									/>
								</div>
							</Button>
							<Button
								className={classes.controlBtn}
								onClick={() => handleMicBtn()}
								color='primary'
							>

								<div className={classes.controlBtnIcon}>
									<Icons category={'guest'} iconName={'mic'} type={settings.audioMuted ? 'active' : 'normal'} size={'1.5rem'}/>
								</div>
								<div className={classes.controlBtnLabel}>
									<FormattedMessage
										id='label.mute'
										defaultMessage='Mute'
									/>
								</div>
							</Button>
							{
								isUploadingFile ?
									<Button
										className={classes.controlBtnDisabled}
										color='primary'
									>
										<div className={classes.controlBtnIcon}>
											<CircularProgress
												className={classes.buttonCircular}
											/>
										</div>
										<div className={classes.controlBtnLabel}>
											<FormattedMessage
												id='label.sharingFile'
												defaultMessage='Sharing Files'
											/>
										</div>
									</Button>
									:
									<Button
										className={classes.controlBtn}
										onClick={startShareFile}
										color='primary'
									>
										<div className={classes.controlBtnIcon}>
											<Icons category={'guest'} iconName={'fileShare'} type={'normal'} size={'1.5rem'}/>
										</div>
										<div className={classes.controlBtnLabel}>
											<FormattedMessage
												id='label.sharingFile'
												defaultMessage='Sharing Files'
											/>
										</div>
									</Button>
							}

							{isMobile ?
								<Button
									className={classes.controlBtn}
									onClick={() => handleChatBtn()}
									color='primary'
								>

									<div className={classes.controlBtnIcon}>
										<Badge variant='dot' color='secondary' invisible={!showChatBadge}>
											<Icons category={'guest'} iconName={'chat'} type={chatEnabled ? 'active' : 'normal'} size={'1.5rem'}/>
										</Badge>
									</div>
									<div className={classes.controlBtnLabel}>
										<FormattedMessage
											id='label.chat'
											defaultMessage='Chat'
										/>
									</div>

								</Button>
								:

								<Button
									className={classes.controlBtn}
									onClick={() => setSettingsDialogOpen(true)}
									color='primary'
								>

									<div className={classes.controlBtnIcon}>
										<Icons category={'guest'} iconName={'settings'} type={'normal'} size={'1.5rem'}/>
									</div>
									<div className={classes.controlBtnLabel}>
										<FormattedMessage

											id='label.settings'
											defaultMessage='Settings'
										/>
									</div>

								</Button>
							}

							<Button
								className={classes.controlBtn}
								onClick={() => handleCloseBtn()}
								color='primary'
							>
								<div className={classes.controlBtnIcon}>
									<Icons category={'host'} iconName={'hungUp'} type={'normal'} size={'1.5rem'}/>
								</div>
								<div className={classes.controlBtnLabel}>
									<FormattedMessage
										id='label.callEnd'
										defaultMessage='Hung Up'
									/>
								</div>
							</Button>

							{/* hidden input in order to update file */}
							<input
								type='file'
								ref={hiddenFileInput}
								onChange={handleShareFile}
								className={classes.hiddenInput}
							/>
						</div>
					</>
					}
				</div>
			}
		</>
	);
};

GuestBottomNavi.propTypes =
{
	room                : PropTypes.object.isRequired,
	roomClient          : PropTypes.object.isRequired,
	peersLength         : PropTypes.number.isRequired,
	classes             : PropTypes.object.isRequired,
	settings            : PropTypes.object.isRequired,
	isMobile            : PropTypes.bool.isRequired,
	chatEnabled         : PropTypes.bool.isRequired,
	setChatEnabled      : PropTypes.func.isRequired,
	setAudioMuted       : PropTypes.func.isRequired,
	setVideoMuted       : PropTypes.func.isRequired,
	orientation         : PropTypes.string,
	uploadedShareFile   : PropTypes.func.isRequired,
	setMakeCallEnd      : PropTypes.func.isRequired,
	numOfRecievedChats  : PropTypes.number.isRequired,
	hideGuestBottomNavi : PropTypes.bool.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		room         : state.room,
		peers        : state.peers,
		peersLength  : peersLengthSelector(state),
		loginEnabled : state.me.loginEnabled,
		loggedIn     : state.me.loggedIn,
		locale       : state.intl.locale,
		localesList  : state.intl.list,
		isMobile     : state.me.browser.platform === 'mobile' || state.me.useMobileView,
		chatEnabled  : state.bottomNavigation.chatEnabled,
		settings     : state.settings,
		orientation  : state.room.orientation ?
			state.room.orientation : state.me.useMobileOrientation,
		numOfRecievedChats  : state.room.numOfRecievedChats,
		hideGuestBottomNavi : state.room.hideGuestBottomNavi
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		setChatEnabled : (flag) =>
		{
			dispatch(bottomNavigationActions.setChatEnabled(flag));
		},
		setAudioMuted : (flag) =>
		{
			dispatch(settingsActions.setAudioMuted(flag));
		},
		setVideoMuted : (flag) =>
		{
			dispatch(settingsActions.setVideoMuted(flag));
		},
		uploadedShareFile : (fileInfo) =>
		{
			dispatch(chatActions.uploadedShareFile(fileInfo));
		},
		setMakeCallEnd : (bool) =>
		{
			dispatch(roomActions.setMakeCallEnd(bool));
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.inLobby === next.room.inLobby &&
				prev.room.signInRequired === next.room.signInRequired &&
				prev.room.overRoomLimit === next.room.overRoomLimit &&
				prev.room.orientation === next.room.orientation &&
				prev.room.logoUrl === next.room.logoUrl &&
				prev.settings.displayName === next.settings.displayName &&
				prev.settings === next.settings &&
				prev.me.displayNameInProgress === next.me.displayNameInProgress &&
				prev.me.loginEnabled === next.me.loginEnabled &&
				prev.me.loggedIn === next.me.loggedIn &&
				prev.me.picture === next.me.picture &&
				prev.intl.locale === next.intl.locale &&
				prev.intl.localesList === next.intl.localesList &&
				prev.peers === next.peers &&
				prev.bottomNavigation === next.bottomNavigation &&
				prev.room.numOfRecievedChats === next.room.numOfRecievedChats &&
				prev.room.hideGuestBottomNavi === next.room.hideGuestBottomNavi&&
				prev.me.useMobileView === next.me.useMobileView &&
				prev.me.useMobileOrientation === next.me.useMobileOrientation
			);
		}
	}
)(withStyles(styles)(GuestBottomNavi)));